///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2021, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { statusText } from "./http";

/**
 * The `FetchError` object indicates an error when request to Open Cloud Server could not be
 * performed. A `FetchError` is typically (but not exclusively) thrown when a network error
 * occurs, access denied, or object not found.
 */

export class FetchError extends Error {
  protected status: number;
  protected statusText: string;

  /**
   * @property status - The <a href="https://developer.mozilla.org/docs/Web/HTTP/Status" target
   *   ="_blank">HTTP status code</a> of the response.
   * @property message - Error message. Inherited from <a
   *   href="https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Error"
   *   target ="_blank">Error</a>.
   */
  constructor(status: number, message?: string) {
    super(message || statusText(status));
    this.status = status;
    this.statusText = statusText(status);
  }
}
